/* tslint:disable */
/* eslint-disable */
/**
 * Magnolia Headless Helper API
 * Helper API and model definitions for breadcrumbs page navigation etc. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
* 
* @export
* @interface ApiBreadCrumb
*/
export interface ApiBreadCrumb {
    /**
    * 
    * @type {string}
    * @memberof ApiBreadCrumb
    */
    title?: string;
    /**
    * 
    * @type {string}
    * @memberof ApiBreadCrumb
    */
    path: string;
}

export function ApiBreadCrumbFromJSON(json: any): ApiBreadCrumb {
return ApiBreadCrumbFromJSONTyped(json, false);
}

export function ApiBreadCrumbFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiBreadCrumb {
    if ((json === undefined) || (json === null)) {
    return json;
    }
    return {
    
                    'title': json['title'],
                    'path': json['path'],
        };
    }

    export function ApiBreadCrumbToJSON(value?: ApiBreadCrumb | null): any {
    if (value === undefined) {
    return undefined;
    }
    if (value === null) {
    return null;
    }
    return {

                'title': value.title,
                'path': value.path,
    };
    }


    // custom code here ##################################################################################################################
    // function toUTC(date) {
    //   var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
    //   return new Date(date_utc);
    // }

